import { Card } from '@material-ui/core'
import React from 'react'
import EditorChordCard from './EditorChordCard'

const ChordProgressionEditor = (props: {
	chords: any,
	onChange: (chords: any) => void,
	onPlayClick: (chord: any) => void,
}) => {

	const {
		chords,
		onChange,
		onPlayClick,
	} = props

	return (
		<div>
			<Card style={{ display: 'flex' }}>
				{chords.map((chord: any, i: number) => (
					<EditorChordCard
						chord={chord}
						onPlayClick={onPlayClick}
						last={i === chords.length - 1}
					/>
				))}
			</Card>
		</div>
	)
}

export default ChordProgressionEditor
